import { Divider } from "antd";
import styled from "styled-components";

export const StyledDivider = styled(Divider)`
    margin-top: 16px;
    margin-bottom: 16px;
`;
